<template>
  <div
    :class="{
      'pool-additional-info-mobile': isMobile,
      'pool-additional-info': !isMobile,
    }"
  >
    <div class="curve">
      <img
        width="15"
        height="15"
        class="curve__img"
        :src="getCurveImg(pool.curve as TCurveType)"
      />
      <span class="curve__label">
        <TextHighlight
          v-if="pool?.curve"
          :text="curve2Label(pool?.curve)"
          :regexp="searchQuery"
        />
      </span>
    </div>
    <div class="contract">
      <img class="contract__img" src="@/assets/contract-version.svg" />
      <span class="contract__label">Ver. {{ pool.contract }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { curve2Label, getCurveImg } from '@/composables/usePoolsTableServices';
import { TCurveType } from '@/types';
import { ITablePool } from '@/types/pools';
import { toRefs } from 'vue';
import { TextHighlight } from '@/components/UI/TextHighlight';
import { useTablePoolStore } from '@/store';
import { storeToRefs } from 'pinia';

interface IProps {
  pool: ITablePool;
  isMobile?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isMobile: false,
});

const { searchQuery } = storeToRefs(useTablePoolStore());
const { pool, isMobile } = toRefs(props);
</script>
<css lang="scss" scoped src="./style.scss" />
